module.exports = "<div class=\"kng-bubble-tip-arrow\"></div><div class=\"kng-bubble-tip-inner\"><ng-content></ng-content></div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-bubble-tip/kng-bubble-tip-window.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-bubble-tip/kng-bubble-tip-window.component.html
// module chunks = main